import { Box } from "@mui/material";

import awsLogo from "../../../../assets/aws-logo.svg";
import awsLogoDark from "../../../../assets/aws-logo-dark-mode.svg";
import gcpLogo from "../../../../assets/gcp-logo.svg";
import { useDarkThemeCheck } from "../../../../Components/hooks/useDarkThemeCheck";
import { useCustomerContext } from "../../../../Context/CustomerContext";
import { useCustomerHasFsk8sAWSPermissions, useCustomerHasFsk8sGCPPermissions } from "../../hooks";
import PermissionBox from "./PermissionBox";

const Fsk8sCloudPermissions = () => {
  const isDarkTheme = useDarkThemeCheck();
  const { customer } = useCustomerContext();

  const { customerHasFsk8sAWSPermissions, loading: awsLoading } = useCustomerHasFsk8sAWSPermissions();
  const { customerHasFsk8sGcpPermissions, loading: gcpLoading } = useCustomerHasFsk8sGCPPermissions();

  const logoSrcs = {
    GKE: gcpLogo,
    EKS: isDarkTheme ? awsLogoDark : awsLogo,
  };

  return (
    <Box
      flexDirection={{
        xs: "column",
        sm: "row",
      }}
      display="flex"
      gap={2}
      width="100%"
    >
      <PermissionBox
        hasPermission={customerHasFsk8sAWSPermissions}
        settingsLink={`/customers/${customer.id}/integrate/aws`}
        name="EKS"
        loading={awsLoading}
        logoSrc={logoSrcs.EKS}
      />
      <PermissionBox
        hasPermission={customerHasFsk8sGcpPermissions}
        settingsLink={`/customers/${customer.id}/integrate/gcp`}
        name="GKE"
        loading={gcpLoading}
        logoSrc={logoSrcs.GKE}
      />
    </Box>
  );
};

export default Fsk8sCloudPermissions;
